import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "../../api.js";
import { PayrollApiError } from "./api.js";

const requestFailure = (error: unknown): number | undefined => {
  if (!(error instanceof ApiRequestError || error instanceof PayrollApiError))
    return undefined;
  return error.status;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = requestFailure(error);
        // A repeated invalid request cannot succeed without an operator change.
        if (status !== undefined && [400, 401, 403, 404, 409, 422].includes(status))
          return false;
        return failureCount < 3;
      },
    },
  },
});
